<app-configuration-page
  title="Export / Backup"
  description="Download a copy of your studio's data at any time. Check the datasets you want and everything is bundled into a single ZIP file."
  [breadcrumbs]="[{ label: 'Export / Backup' }]">

  <div *ngIf="loadingManifest" class="text-muted d-flex align-items-center">
    <mat-spinner diameter="20" class="me-2"></mat-spinner> Loading export options&hellip;
  </div>

  <ng-container *ngIf="!loadingManifest">
    <h4 class="mt-2 mb-3">What to include</h4>

    <div class="row">
      <div class="col-md-6 mb-3" *ngFor="let dataset of datasets">
        <div class="card h-100" [class.opacity-50]="!dataset.available">
          <div class="card-body d-flex">
            <mat-icon class="me-3 text-muted" style="font-size: 28px; width: 28px; height: 28px;">{{ dataset.icon }}</mat-icon>
            <div class="flex-grow-1">
              <div class="d-flex align-items-center justify-content-between">
                <h6 class="card-title mb-1">{{ dataset.label }}</h6>
                <mat-checkbox
                  [(ngModel)]="dataset.selected"
                  [disabled]="!dataset.available || bulkExporting"
                  [matTooltip]="dataset.available ? '' : 'Coming soon'">
                </mat-checkbox>
              </div>
              <p class="card-text text-muted small mb-0">{{ dataset.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center mt-4 pt-3 border-top">
      <button
        mat-flat-button
        color="primary"
        (click)="exportSelected()"
        [disabled]="!anySelected || bulkExporting">
        <mat-icon>cloud_download</mat-icon>
        <span *ngIf="!bulkExporting">Download Backup</span>
        <span *ngIf="bulkExporting">Preparing ZIP&hellip;</span>
      </button>
      <span class="ms-3 text-muted small">All checked datasets bundled into a single ZIP.</span>
    </div>
  </ng-container>

</app-configuration-page>
